import range from 'ramda/src/range'

const createSingleIntegerRange = n =>
  range(0, 10)
    .reduce((acc, val) => [ ...acc, parseFloat(`${n}.${val}`) ], [])

export default function decimalRange(range) {
  if (!range.includes(360)) {
    return range
      .reduce((acc, val) => [ ...acc, ...createSingleIntegerRange(val) ], [])
      .slice(0, -9)
  } else if (range[0] === 360) {
    return [ 360 ]
  } else {
    return [
      ...range
        .slice(0, -1)
        .reduce((acc, val) => [ ...acc, ...createSingleIntegerRange(val) ], [])
        .slice(0, -9),
      220,
      270,
      360
    ]
  }
}



// WEBPACK FOOTER //
// ./src/helpers/aovDecimalRange.js